var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticStyle:{"height":"100%"}},[_c('loader',{attrs:{"size":"xxs","loader-image":false}})],1):_c('div',{staticClass:"cardClass"},[_vm._t("default"),(_vm.hasFooterSlot)?_c('footer',{staticClass:"flex",class:_vm.footerHasBorder ? 'cardFooter' : ''},[_vm._t("footer")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }